import { Module } from "vuex";
import {
  ModalConfigStruct,
  ModalPresetsStruct,
} from "@/struct/ui/UIModalStruct";
import { MODAL_PRESETS, TypesModals } from "@/config/modals";
import type { RootState } from "@/store";

export interface SystemState {
  activeConfig: ModalConfigStruct | null;
  isLogoHidden: boolean;
  isAsideHidden: boolean;
  showPaymentModal: boolean;
  promoModalShown: boolean;
}

const systemModule: Module<SystemState, RootState> = {
  namespaced: true,
  state: () => ({
    activeConfig: null,
    isLogoHidden: false,
    isAsideHidden: false,
    showPaymentModal: false,
    promoModalShown: false,
  }),
  getters: {},
  mutations: {
    OPEN_MODAL(state, payload: ModalConfigStruct) {
      state.activeConfig = payload;
    },
    CLOSE_MODAL(state) {
      state.activeConfig = null;
    },
    SET_BTN_LOADING_MODAL(
      state,
      payload: { btn: "main" | "secondary"; loading: boolean }
    ) {
      if (state.activeConfig) {
        if (payload.btn === "main") {
          state.activeConfig.mainBtnLoading = payload.loading;
        } else {
          state.activeConfig.secondaryBtnLoading = payload.loading;
        }
      }
    },
    SET_LOGO_VISIBILITY(state, isHidden: boolean) {
      state.isLogoHidden = isHidden;
    },
    SET_ASIDE(state, isHidden: boolean) {
      state.isAsideHidden = isHidden;
    },
    SET_SHOW_PAYMENT_MODAL(state, isShowed: boolean) {
      state.showPaymentModal = isShowed;
    },
    SET_PROMO_MODAL_SHOWN(state, value: boolean) {
      state.promoModalShown = value;
    },
  },
  actions: {
    openModal(
      { commit },
      payload: {
        presetKey: TypesModals;
        overrides?: Partial<ModalPresetsStruct>;
        onAction?: () => void;
        onSecondaryAction?: () => void;
      }
    ) {
      const staticPreset = MODAL_PRESETS[payload.presetKey];
      commit("OPEN_MODAL", {
        mainBtnLoading: false,
        secondaryBtnLoading: false,
        ...staticPreset,
        ...payload.overrides,
        onAction: payload.onAction,
        onSecondaryAction: payload.onSecondaryAction,
      });
    },

    closeModal({ commit }) {
      commit("CLOSE_MODAL");
    },

    updateLogoVisibility({ commit }, isHidden: boolean) {
      commit("SET_LOGO_VISIBILITY", isHidden);
    },

    updateAsideVisibility({ commit }, isHidden: boolean) {
      commit("SET_ASIDE", isHidden);
    },
    togglePaymentModal({ commit }, isShowed: boolean) {
      commit("SET_SHOW_PAYMENT_MODAL", isShowed);
    },
    markPromoModalShown({ commit }) {
      commit("SET_PROMO_MODAL_SHOWN", true);
    },
  },
};

export default systemModule;
